export const BREAKPOINTS = {
  MOBILE: 'max-width: 767px',
  TABLET: 'min-width: 768px) and (max-width: 991px',
  DESKTOP: 'min-width: 992px',
  LAYOUT: 'max-width: 1300px',
} as const;
